var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.048 13.75L11.0481 10.2885L0 10.2885V9.71154L11.0481 9.71154L11.048 6.25L20 10L11.048 13.75Z","fill":"#D93600"}));
}

ArrowRight.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
